import React from 'react';

// Types
import { TableBreadCrumbsProps } from './types';

// Components
import { WpBreadcrumbs, WpBreadcrumbItem } from '../breadcrumbs';

// Styles
import './TableBreadcrumbs.scss';

const TableBreadcrumbs = ({
  tableId,
  data,
  selectedData,
  nestedKey,
  uniqueIdentifier,
  handleSelectSubItem,
  labelIdentifier,
  pluralItemLabel,
}: TableBreadCrumbsProps) => {
  if (!selectedData) return null;
  if (!labelIdentifier(selectedData[0])) return null;
  if (!uniqueIdentifier(selectedData[0])) return null;

  const getId = item => uniqueIdentifier(item);

  const getSubItems = item => {
    return nestedKey(item) || [];
  };

  const flattenData = data => {
    if (data.length === 0) return [];
    return [...data, ...data.map(datum => flattenData(getSubItems(datum))).flat()];
  };

  const flattenedData = flattenData(data);
  const buildBreadCrumbList = lastItem => {
    if (!lastItem) return [];

    const parentOfLastItem = flattenedData.find(potentialParentOfLastItem => {
      const subItems = getSubItems(potentialParentOfLastItem);
      return subItems.find(subItem => getId(subItem) === getId(lastItem));
    });

    if (!parentOfLastItem) return [lastItem];

    return [...buildBreadCrumbList(parentOfLastItem), lastItem];
  };

  const crumbMap = buildBreadCrumbList(selectedData[0]);

  const handleBackToAllItems = () => {
    handleSelectSubItem(null);
  };

  const baseClassName = 'TableBreadcrumbs';

  return (
    <tbody>
      <tr>
        <td colSpan={100} className={`${baseClassName}__td`}>
          <WpBreadcrumbs>
            <WpBreadcrumbItem label={`All ${pluralItemLabel}`} onClick={handleBackToAllItems} />
            {crumbMap.map((crumb, i) => (
              <WpBreadcrumbItem
                key={`${tableId}--breadcrumb-${i}`}
                label={labelIdentifier(crumb)}
                onClick={() => handleSelectSubItem([crumb])}
              />
            ))}
          </WpBreadcrumbs>
        </td>
      </tr>
    </tbody>
  );
};

export default TableBreadcrumbs;
